import { theme } from 'Assets/Styles/theme'

export default ({ props }) => {
  const accentColor = props.color || theme.colors.primary

  return {
    wrapper: {
      display: 'grid',
      gridTemplateColumns: '7fr 1px 3fr',
      height: '100%',
    },
    separator: {
      width: '1px',
      backgroundColor: '#ccc',
      minHeight: 'calc(100vh - 190px)',
    },
    title: {
      fontWeight: 'bold',
      fontSize: '24px',
      color: accentColor,
      marginRight: '24px',
    },
    header: { display: 'flex' },
  }
}
